import React, { memo } from "react";
import UnderOverCard from "./card/UnderOverCard";
import ColorCard from "./card/ColorCard";
import RangeCard from "./card/RangeCard";
import CircleGrid from "./CircleGrid";

const BettingBoard = (props) => {
    const { t, config } = props;
    const rouletteBetTypes = config?.rouletteBetTypes;

    if (!rouletteBetTypes) return null;

    const {
        underOverOddEven = [],
        colors = [],
        numbers = [],
        range = [],
    } = rouletteBetTypes;

    return (
        <>
            <div className="bet-type-wrap">
                <div className="bet-types">
                    {underOverOddEven.map((item, index) => (
                        <UnderOverCard
                            key={item?.code || item?.name || index}
                            t={t}
                            item={item}
                            {...props}
                        />
                    ))}
                </div>

                <div className="colors-group">
                    {colors.map((color, index) => (
                        <ColorCard
                            key={color?.code || color?.name || index}
                            index={index}
                            color={color}
                            {...props}
                        />
                    ))}
                </div>
            </div>

            <div className="ranges-group">
                {range.map((item, index) => (
                    <RangeCard
                        key={item?.code || item?.name || index}
                        item={item}
                        {...props}
                    />
                ))}
            </div>

            <div className="betting-buttons-section">
                <div className="betting-numbers-wrapper">
                    <div className="betting-numbers">
                        <CircleGrid numbers={numbers} {...props} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default memo(BettingBoard);